export const GenerateSchema = (type, data = {}) => {
  
  const commonAddress = {
    "@type": "PostalAddress",
    "streetAddress": "Unit No 22, Building No. 2(A3), Sector 1, Millennium Business Park, Mahape",
    "addressLocality": "Navi Mumbai",
    "addressRegion": "Maharashtra",
    "postalCode": "400710",
    "addressCountry": "IN"
  };
  const commonProvider = {
    "@type": "LocalBusiness",
    "@id": "https://dronedidi.co.in/#organization",
    "name": "Precision Grow",
    "url": "https://dronedidi.co.in/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://dronedidi.co.in/static/media/l2.bf7c4b0256c39b017561.png",
      "width": 250,
      "height": 60
    },
    "sameAs": [
      "https://www.facebook.com/PrecisionGrow",
      "https://twitter.com/precision_grow",
      "https://www.instagram.com/precisiongrow_/",
      "https://www.youtube.com/channel/UCt1nu8YiUMjnvckNLfepa5g",
      "https://www.linkedin.com/company/precisiongrow"
    ],
    "email": "mail@precisiongrow.co.in",
"telephone": "+91-8097283444",
"address": commonAddress,
  };

  const commonContact = {
    "@type": "ContactPoint",
    "telephone": "+91-8097283444",
    "contactType": "customer support",
    "email": "mail@precisiongrow.co.in",
    "areaServed": "IN",
    "availableLanguage": ["English", "Hindi"]
  };


  switch (type) {
    case "HomePage":
      return {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Organization",
            ...commonProvider, // Already includes name, url, logo, and social links
            "description": "Drone Didi is an initiative born out of the need to combine technology with women empowerment. We aspire eco-friendly growth, families flourish, communities rise and future-proof farming.",
            "email": "mail@precisiongrow.co.in",
            "contactPoint": [commonContact],
            "address": commonAddress
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": {
                  "@type": "WebPage",
                  "name": "Home",
                  "url": "https://dronedidi.co.in/"
                }
              }
            ]
          }
        ]
      };
    
      case "AboutPage":
        return {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "name": "About Precision Grow: Innovating Sustainable Agri-Tech Solutions",
              "url": "https://dronedidi.co.in/about",
              "description": "We are honored to champion the Government of India's revolutionary Namo Drone Didi Scheme. We are building a skybridge between cutting-edge technology and the heart of rural India. | A field where innovation meets empowerment."
            },
            {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": {
                    "@type": "WebPage",
                    "@id": "https://dronedidi.co.in/",
                    "url": "https://dronedidi.co.in/",
                    "name": "Home"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "About",
                  "item": {
                    "@type": "WebPage",
                    "@id": "https://dronedidi.co.in/about",
                    "url": "https://dronedidi.co.in/about",
                    "name": "About"
                  }
                }
              ]
            }
          ]
        };
    

     case "ContactPage":
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ContactPage",
        "name": "Contact DroneDidi - Your Agri-Tech Partner",
        "url": "https://dronedidi.co.in/contact",
        "description":
          "For any query, call us directly at +91 80972 834 44 or email us at mail@precisiongrow.co.in. You can get in touch with us through our website too.",
        "about": {
          ...commonProvider,
          "contactPoint": commonContact,
          "address": commonAddress
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://dronedidi.co.in/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Contact",
            "item": "https://dronedidi.co.in/contact"
          }
        ]
      }
    ]
  };


        // case "BlogPage":
        //   const isDetailPage = data && data.slug; 
      
        //   return {
        //     "@context": "https://schema.org",
        //     "@graph": [
        //       {
        //         "@type": isDetailPage ? "Article" : "CollectionPage",
        //         "mainEntityOfPage": {
        //           "@type": "WebPage",
        //           "@id": isDetailPage 
        //             ? `https://dronedidi.co.in/post/${data.slug}` 
        //             : "https://dronedidi.co.in/blog"
        //         },
        //         "name": isDetailPage ? data.title : "Precision Grow Blog",
        //         "url": isDetailPage 
        //           ? `https://dronedidi.co.in/post/${data.slug}` 
        //           : "https://dronedidi.co.in/blog",
        //         "description": isDetailPage 
        //           ? data.metaDescription || "Read about the latest advancements in agriculture, satellite monitoring, and AI-driven farming." 
        //           : "Explore the latest insights on agriculture, satellite monitoring, and AI-driven farming.",
          //       ...(isDetailPage && data.imageURL ? { "image": data.imageURL } : {}), 
          //       ...(isDetailPage && data.authorName ? { "author": { "@type": "Person", "name": data.authorName } } : {}), 
          //       ...(isDetailPage && data.datePublished ? { "datePublished": data.datePublished } : {}),
          //       ...(isDetailPage && data.dateModified ? { "dateModified": data.dateModified } : {}),
          //       "publisher": commonProvider
          //     },
          //     {
          //       "@type": "BreadcrumbList",
          //       "itemListElement": [
          //         {
          //           "@type": "ListItem",
          //           "position": 1,
          //           "name": "Home",
          //           "item": "https://dronedidi.co.in/"
          //         },
          //         {
          //           "@type": "ListItem",
          //           "position": 2,
          //           "name": "Blog",
          //           "item": "https://dronedidi.co.in/blog"
          //         },
          //         ...(isDetailPage
          //           ? [
          //               {
          //                 "@type": "ListItem",
          //                 "position": 3,
          //                 "name": data.title,
          //                 "item": `https://dronedidi.co.in/post/${data.slug}`
          //               }
          //             ]
          //           : [])
          //       ]
          //     }
          //   ]
          // };
      

          case "ServicePage":
            return {
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": "Service",
                  "@id": data.url || "https://dronedidi.co.in/drone_health_check",
                  "url": data.url || "https://dronedidi.co.in/drone_health_check",
                  "name": data.name || "DroneDidi Service",
                  "serviceType": data.serviceType || "Agriculture Service",
                  "description": data.description || "At Drone Didi, we provide complete inspection of your drone, battery & power testing, drone’s software updates and preventive maintenance.",
                  "provider": { ...commonProvider, "contactPoint": commonContact },
                  "areaServed": { "@type": "Country", "name": "India" },
                  "serviceAudience": { "@type": "Audience", "name": "Farmers and Agri-Businesses" },
                  "image": "https://dronedidi.co.in/static/media/99_offer_AD.07511ffb52a9a81d854f.webp"
                },
                {
                  "@type": "BreadcrumbList",
                  "@id": "https://dronedidi.co.in/#breadcrumb",
                  "itemListElement": [
                    {
                      "@type": "ListItem",
                      "position": 1,
                      "name": "Home",
                      "item": "https://dronedidi.co.in/"
                    },
                    {
                      "@type": "ListItem",
                      "position": 2,
                      "name": data.name || "Service",
                      "item": data.url || "https://dronedidi.co.in/drone_health_check"
                    }
                  ]
                }
              ]
            };
        


      
        case "SustainabilityPage":
          return {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "name": "Sustainable Development At Drone Didi",
                "url": "https://dronedidi.co.in/sustainability",
                "description": "With Drone Didi, sustainability is not just about crops, but about creating strong communities, empowered women and a future that thrives.",
                "about": {
                  ...commonProvider,
                  "contactPoint": commonContact,
                  "address": commonAddress
                }
              },
              {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://dronedidi.co.in/" },
                  { "@type": "ListItem", "position": 2, "name": "Sustainability", "item": "https://dronedidi.co.in/sustainability" }
                ]
              }
            ]
          };
        

      
         
    
    default:
      return null;
  }
};
